import Colors from '../../utils/colors';

const FileUpload = ({ 
  accept = "*", 
  onChange, 
  placeholder = "Click to select file",
  description = "Select a file to upload",
  value = null
}) => {
  const handleFileChange = (e) => {
    const selectedFile = e.target.files[0];
    if (onChange) {
      onChange(selectedFile);
    }
  };

  return (
    <div
      style={{
        border: `2px dashed ${value ? Colors.primary : Colors.lightGray}`,
        borderRadius: '8px',
        padding: '24px',
        textAlign: 'center',
        backgroundColor: value ? Colors.successLight : Colors.white,
        transition: 'all 0.3s ease',
        cursor: 'pointer',
        position: 'relative'
      }}
      onClick={() => document.getElementById('file-input').click()}
    >
      <input
        id="file-input"
        type="file"
        accept={accept}
        onChange={handleFileChange}
        style={{ display: 'none' }}
      />
      {value ? (
        <div>
          <div style={{ fontSize: '14px', color: Colors.primary, fontWeight: 600, marginBottom: '4px' }}>
            ✓ File Selected
          </div>
          <div style={{ fontSize: '12px', color: Colors.gray }}>
            {value.name}
          </div>
          <div style={{ fontSize: '10px', color: Colors.gray, marginTop: '4px' }}>
            Click to change file
          </div>
        </div>
      ) : (
        <div>
          <div style={{ fontSize: '14px', color: Colors.gray, marginBottom: '4px' }}>
            📁 {placeholder}
          </div>
          <div style={{ fontSize: '12px', color: Colors.lightGray }}>
            {description}
          </div>
        </div>
      )}
    </div>
  );
};

export default FileUpload;